"use client";

import React, { createContext, useContext, useMemo } from "react";
import type { FUSportsEvent, SearchEntityResult } from "fansunited-data-layer";

export interface CompetitionCarouselDataValue {
    events: FUSportsEvent[];
    entities: Record<string, SearchEntityResult>;
}

const CompetitionCarouselDataContext = createContext<CompetitionCarouselDataValue | null>(null);

interface CompetitionCarouselDataProviderProps extends CompetitionCarouselDataValue {
    children: React.ReactNode;
}

export function CompetitionCarouselDataProvider({ events, entities, children }: CompetitionCarouselDataProviderProps) {
    const value = useMemo(() => ({ events, entities }), [events, entities]);
    return <CompetitionCarouselDataContext.Provider value={value}>{children}</CompetitionCarouselDataContext.Provider>;
}

/**
 * Consumers get the seeded events + entities. Returns `null` when the
 * provider is absent (e.g. a variant without a match carousel), letting
 * callers gracefully degrade instead of throwing.
 */
export function useCompetitionCarouselData(): CompetitionCarouselDataValue | null {
    return useContext(CompetitionCarouselDataContext);
}
